import css from './table.module.css';
import type { ReactNode } from 'react';
export function Table({
  children
}: {
  children: ReactNode;
}) {
  return <div className={css.tableContainer} data-sentry-component="Table" data-sentry-source-file="table.tsx">
            <table className={css.articleTable}>{children}</table>
        </div>;
}